import { useFormContext } from 'react-hook-form';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

import { useFieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';

import {
  DistanceRangeFromField,
  DistanceRangeToField,
  ExpensesMaxField,
  ExpensesNominalField,
  ExpensesPerDistanceField,
  ValidFromField,
  ValidToField
} from './components/TravelLineFields';
import {
  GridContainer,
  GridCompact4,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const EditTravelLine = ({ rowId }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArrayContext();
  const fieldIndex = useFindIndexFromFieldsArray(
    rowId ?? getLastAddedFieldId(fields),
    fields
  );

  return (
    <>
      <GridContainer>
        <GridCompact6>
          <DistanceRangeFromField
            name={`travelSetLines[${fieldIndex}].distanceRangeFrom`}
          />
        </GridCompact6>
        <GridCompact6>
          <DistanceRangeToField
            name={`travelSetLines[${fieldIndex}].distanceRangeTo`}
          />
        </GridCompact6>
        <GridCompact4>
          <ExpensesPerDistanceField
            name={`travelSetLines[${fieldIndex}].expensesPerDistance`}
          />
        </GridCompact4>
        <GridCompact4>
          <ExpensesNominalField
            name={`travelSetLines[${fieldIndex}].expensesNominal`}
          />
        </GridCompact4>
        <GridCompact4>
          <ExpensesMaxField
            name={`travelSetLines[${fieldIndex}].expensesMax`}
          />
        </GridCompact4>
        <GridCompact6>
          <ValidFromField
            name={`travelSetLines[${fieldIndex}].valid.from`}
            control={control}
          />
        </GridCompact6>
        <GridCompact6>
          <ValidToField
            name={`travelSetLines[${fieldIndex}].valid.to`}
            control={control}
          />
        </GridCompact6>
      </GridContainer>
    </>
  );
};

export default EditTravelLine;
